module.exports = __webpack_public_path__ + "static/media/06.e6299b29.jpg";